export default __webpack_public_path__ + "static/media/venza-landing-img.17034abd.png";